module.exports = __webpack_public_path__ + "static/media/po.44161676.gif";